import BaseRepository from './base.repository';

class ArticleRepository extends BaseRepository {
  constructor() {
    super('/savanne');
  }

  findContentDetail(mainUnique) {
    return this.client.get(`/treatment-content/${mainUnique}`);
  }

  bookmark(mainUnique) {
    return this.client.post(`/treatment-content/bookmark/${mainUnique}`);
  }

  deleteBookmark(mainUnique) {
    return this.client.delete(`/treatment-content/bookmark/${mainUnique}`);
  }
}

export default new ArticleRepository();
